function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m5.785 21.134.315-2.963 9.931-8.942 2.665 2.96-9.93 8.942-2.98.003Zm14.769-10.618-2.665-2.96 1.99-1.792 2.666 2.96-1.991 1.792ZM3.123 22.531a1 1 0 0 0 .995 1.105l5.225-.006a1 1 0 0 0 .668-.257L25.332 9.578a1 1 0 0 0 .074-1.412l-4.672-5.19a1 1 0 0 0-1.412-.073L4 16.698a1 1 0 0 0-.325.637l-.552 5.196ZM28.5 26.4a.4.4 0 0 0-.4-.4H3.9a.4.4 0 0 0-.4.4v1.7c0 .22.18.4.4.4h24.2a.4.4 0 0 0 .4-.4v-1.7Z"
  }));
};
var componentName = 'EditOutlined';
export var EditOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
EditOutlined.displayName = componentName;